<template>
  <card title="Selected session" subTitle="Please select one" v-if="selected == null">
  </card>
  <card title="Current session" :subTitle="selected.sessionId" v-if="selected != null">
    <div class="table-responsive">
      <table class="table">
        <tbody>
        <tr>
          <td class="font-weight-bold">Session</td>
          <td class="">{{ selected.name }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">Provider</td>
          <td class="">{{ selected.provider }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">Description</td>
          <td class="">{{ selected.description }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">Date</td>
          <td class="">{{ frontEndDateFormat(selected.dateStart) }}</td>
        </tr>
        </tbody>
      </table>

    </div>
  </card>
</template>
<script>
import moment from 'moment'

export default {
  name: 'session-table',
  props: {
    // selected: Array,
    selected: Object,

  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    }
  },
  methods: {
    frontEndDateFormat: function (date) {
      return moment(date).format('DD/MM/YYYY hh:mm');
    },

    // hasValue(item, column) {
    //   return item[column.toLowerCase()] !== "undefined";
    // },
    // itemValue(item, column) {
    //   return item[column.toLowerCase()];
    // }
  }
};
</script>
<style>
</style>
